export enum ConnectionState {
	CLOSED = 'CLOSED',
	CONNECTING = 'CONNECTING',
	OPEN = 'OPEN',
	CLOSING = 'CLOSING',
}
